import React, { useEffect, useState } from "react";
import Notification from "../../../components/Notification";
import HeaderRelatorio from "../HeaderRelatorio";
import PageTitle from "../../../components/PageTitle/PageTitle";
import Table from "../../../components/Table/Table";
import { CircularProgress, Grid, withStyles } from "@material-ui/core";
import { Button } from "../../../components/ui/Buttons";
import ArrowDownloadIcon from "../../../components/Icon/ArrowDownload";
import PrintIcon from "../../../components/Icon/Print";
import ImpressaoHtml from "../../../components/Impressao/ImpressaoHtml";
import { inject } from "mobx-react";
import { situacoes } from "../../SujeitoAtencao/Manutencao/Constants";
import { getProfissionalSaudeLogado } from "../../../services/UsuarioService";
import { findAllConvenio, findAllProfissionalSaude, relatorioAgendamentosRepasseSintetico, relatorioAgendamentosRepasseSinteticoCsv, relatorioAgendamentosRepasseValorTotal } from "../../../services/RelatorioService";
import moment from "moment";
import { applyCurrencyMask } from "../../../utils/CurrencyMask";
import styles from "../RelatorioRepasseSInteticoStyles";
import { observer } from "mobx-react-lite";
import { columns } from "./contantsRelatorioSintetico";
import PopperCheck from "../../../components/Popper/PopperCheck";
import { TextFieldSearch } from "../../../components/TextField";
import InputDateForm from "../../../components/Input/InputDateForm";
import { findAllAgendamentoTipo } from "../../../services/AgendamentoTipoService";
import { base64Convert } from "../../../utils/base64ToCsv";
import RelatorioRepasseSinteticoPdf from "../../../template/pdf/relatorio/RelatorioRepasseSinteticoPdf";
import { ReactSelect } from "../../../components/Select/SelectSearch";

const primeiroDiaDoMes = moment().startOf("month");
const ultimoDiaDoMes = moment().endOf("month");

const filtersDefault = {
  dataInicial: primeiroDiaDoMes.format("YYYY-MM-DD"),
  dataFinal: ultimoDiaDoMes.format("YYYY-MM-DD"),
  profissionalSaude: null,
  situacoes: [
    "AGENDADO",
    "CONFIRMADO",
    "AGUARDANDO",
    "ATENDENDO",
    "CANCELADO",
    "EXCLUIDO",
    "BLOQUEADO",
    "FALTOU",
  ],
  tipo: null,
  convenio:null
};

const RelatorioRepasseSintetico = observer((props) => {
  const { classes, configuracaoImpressaoStore } = props;
  
    const [filters, setFilters] = useState(filtersDefault);
    const [agendamentosRepasses, setAgendamentosRepasses] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [printing, setPrinting] = useState(false);
    const [valorTotal, setValorTotal] = useState(0);
    const [tiposAtendimento,setTiposAtendimentos]=useState([])
    const [situacoesList, setSituacoesList] = useState(situacoes.map(item => {
      return item.value === "ATENDIDO" ? { ...item, checked: true } : { ...item, checked: false }
    }));
    const [ordenarTabela, setOrdenarTabela] = useState({
      sortField: "data",
      sortDir: "ASC",
    });
    const { notification } = configuracaoImpressaoStore;
  
    const usuarioLogado = JSON.parse(localStorage[`_immortal|usuarioLogado`] || null)
    const canViewOutros = usuarioLogado.authorities.some(item => item.authority === 'ROLE_AGENDAMENTO_READ_OUTROS_PROFISSIONAIS');  
    


    useEffect(() => {
      loadAgendamentosRepasses(true);
    }, [filters, ordenarTabela])
  
    useEffect(() => {
      search === "" && loadAgendamentosRepasses(true)
    }, [search])
  
    useEffect(() => {
      loadTiposAtendimento();
    }, []);
  
    const loadTiposAtendimento = async () => {
      try {
        const response = await findAllAgendamentoTipo();
        setTiposAtendimentos(response.data.data.findAllAgendamentoTipo);
      } catch (error) {
        console.error(error);
      }
    };
  
    const onClickPesquisar = () => {
      loadAgendamentosRepasses(true);
    };
  
    const getValorTotalRepasse = async() => {
      const { situacoes, dataInicial, dataFinal, profissionalSaude, tipo ,convenio} = filters;
      const profissional = canViewOutros ? profissionalSaude : await getProfissionalSaudeLogado();
  
      const variables = {
        situacoes,
        dataInicial,
        dataFinal,
        ...(profissional?.id && {
          profissionalSaudeId: profissional.id
        }),
        tipoId: tipo?.id,
        search,
        convenioId: convenio?.id
      };
  
      const response = await relatorioAgendamentosRepasseValorTotal(variables);
      setValorTotal(response)
    };
  
    const loadAgendamentosRepasses = async (clear = false) => {
      try {
        setLoading(true);
        const { situacoes, dataInicial, dataFinal, profissionalSaude, tipo ,convenio} = filters;
  
        const profissional = canViewOutros ? profissionalSaude : await getProfissionalSaudeLogado();
  
        const variables = {
          search: {
            situacoes,
            dataInicial,
            dataFinal,
            ...(profissional?.id && {
              profissionalSaudeId: profissional.id
            }),
            tipoId: tipo?.id,
            convenioId: convenio?.id,
            search,
          },
        }
  
        const response = await relatorioAgendamentosRepasseSintetico(variables);
        setAgendamentosRepasses(response);
        setTotalElements(totalElements);
        getValorTotalRepasse();
  
      } catch (e) {
        configuracaoImpressaoStore.openNotification("Erro ao carregar a lista de repasses", "error");
      } finally {
        setLoading(false);
      }
  
    };
  
    const handleClickClearPesquisar = () => {
      setSearch("");
    };
  
    const handleSearchChange = e => {
      setSearch(e.target.value);
    };
  
    const onKeypressSearch = (e) => {
      if (e.key === 'Enter' && search.length >= 3) {
        loadAgendamentosRepasses(true);
      }
    };
  
    const changeCheckbox = (e, index) => {
      let situacoes = situacoesList;
      let actualState = situacoes[index].checked;
      situacoes[index].checked = !actualState;
      setSituacoesList(situacoes);
      const statusChecked = situacoes
        .filter((value) => !value.checked)
        .map(({ value }) => value);
  
      setFilters({
        ...filters,
        situacoes: statusChecked
      })
      loadAgendamentosRepasses(true);
    };
  
    const quantidadeChecked = () => {
      const situacoesChecked = situacoesList.filter((item) => item.checked);
      const quantidadeChecked = situacoesChecked.length;
  
      const quantidade = {
        [situacoes.length]: "Todos",
        0: "Selecione",
      };
  
      return quantidade[quantidadeChecked] || `${quantidadeChecked} selecionados`;
    };
  
    const printRelatorio = async () => {
      setPrinting(true);
    };

    const relatorioCsv = async () => {
      try {
        const {
          dataFinal,
          dataInicial,
          profissionalSaude,
          situacoes,
          tipo,
        } = filters;
        const variables = {
          search: {
            situacoes,
            dataInicial,
            dataFinal,
            ...(profissionalSaude?.id && {
              profissionalSaudeId: profissionalSaude.id,
            }),
            tipoId: tipo?.id,
            search,
          },

          pageableDto: {
            pageNumber: 0,
            pageSize: totalElements,
            sortDir: ordenarTabela.sortDir,
            sortField: ordenarTabela.sortField,
          },
        };

        const response = await relatorioAgendamentosRepasseSinteticoCsv(
          variables
        );
        return response;
      } catch {
        configuracaoImpressaoStore.openNotification(
          "Erro ao tentar baixar o relatório",
          "error"
        );
      }
    };
  
    const getCsv = async () => {
      const base64 = await relatorioCsv();
      if (base64 !== "error") {
        const blob = base64Convert(base64);
        const url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "relatorioAgendamentosRepasse.csv");
        document.body.appendChild(link);
        link.click();
      }
    };
  
    const handleProfissionalLoadOptions = async (
      search,
      loadedOptions,
      { page }
    ) => {
      return handleLoadMoreOptions({
        search,
        loadedOptions,
        data: { page },
      });
    };
  
    const handleLoadMoreOptions = async ({ search, data }) => {
      let searchDTO = {};
  
      if (data.searchDTO) {
        searchDTO = {
          ...data.searchDTO,
        };
      }
      const response = await findAllProfissionalSaude({
        pageNumber: data.page,
        search,
        ...searchDTO,
      });
  
      return {
        options: response.content,
        hasMore: !response.last,
        additional: {
          page: data.page + 1,
        },
      };
    };
  
    const findAllConvenios = async(  search,loadedOptions,{ page })=>{
     try{ const variables = {
        searchDTO:{
          search,
        },
        pageableDto:{
          pageNumber: page,
          pageSize: 30,
          sortDir: 'ASC',
          sortField:'descricao'
        }
      }
      const {content, last } = await findAllConvenio(variables)
  
      return {
        options:content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      }}catch(error){
      console.error(error)
      }
    }
  
    const handleProfissionalChange = (e) => {
      setFilters({
        ...filters,
        profissionalSaude: e
      });
    };
  
    const handleClickOrdenar = async (value) => {
      const sortDir =
        ordenarTabela.sortField !== value
          ? "ASC"
          : ordenarTabela.sortDir === "ASC"
            ? "DESC"
            : "ASC";
  
      setOrdenarTabela({
        sortDir: sortDir,
        sortField: value,
      });
    };
  
    const handleDateChange = (e, field) => {
      const dataFormatada = e && moment(e).format("YYYY-MM-DD");
      setFilters({
        ...filters,
        [field]: dataFormatada
      });
    };
  
    const handleChangeTipoAtendimento = (value)=>{
      
      setFilters({
        ...filters,
        tipo: value
      })
    }
  
    const handleChangeConvenio = (convenio)=>{
  
      setFilters({
        ...filters,
        convenio: convenio
      })
    }

  return (
    <div className={classes.content}>
      <HeaderRelatorio
        idPrefix="rel-rps"
        search={onClickPesquisar}
        clearSearch={handleClickClearPesquisar}
        value={search}
        title='Repasse Sintético'
        totalTitle='agendamentos'
        onChange={handleSearchChange}
        onKeyPress={onKeypressSearch}
        totalAgendamentos={totalElements}
        hiddenButtons
        hiddenFilter
        infosHeader={[{
          title: 'Valor de repasse total',
          label: applyCurrencyMask(valorTotal)
        }]}
      />

      <div className={classes.filtros}>
        <PageTitle title="Relatórios - Repasse Sintético" />
        <Grid item xs={3} className={classes.spacing}>
                  <span className={classes.tituloFiltros}> Data início: </span>
                  <InputDateForm
                    id="rel-rps-inp-ini"
                    iconposition="end"
                    openTo="day"
                    views={["year", "month"]}
                    value={filters.dataInicial}
                    onChange={(e) => handleDateChange(e, "dataInicial")}
                  />
                </Grid>
                <Grid item xs={3} className={classes.spacing}>
                  <span className={classes.tituloFiltros}> Data fim: </span>
                  <InputDateForm
                    id="rel-rps-inp-fim"
                    iconposition="end"
                    openTo="day"
                    views={["year", "month"]}
                    value={filters.dataFinal}
                    onChange={(e) => handleDateChange(e, "dataFinal")}
                  />
                </Grid>
                {canViewOutros && <Grid item xs={3} className={classes.spacing}>
                  <span className={classes.tituloFiltros}> Profissional: </span>
                  <TextFieldSearch
                    id="rel-rps-sel-prf"
                    placeholder="Selecione"
                    classNotched={classes.notchedOutline}
                    classInput={classes.inputTextField}
                    classIcons={classes.classIcons}
                    loadOptions={handleProfissionalLoadOptions}
                    withPaginate
                    value={filters.profissionalSaude}
                    onChange={handleProfissionalChange}
                    debounceTimeout={300}
                    additional={{
                      page: 0,
                    }}
                  />
                </Grid>}
                <Grid item xs={3} className={classes.spacing}>
                  <span className={classes.tituloFiltros}> Convênio: </span>
                  <TextFieldSearch
                    id="rel-rps-sel-con"
                    placeholder="Selecione"
                    classNotched={classes.notchedOutline}
                    classInput={classes.inputTextField}
                    classIcons={classes.classIcons}
                    loadOptions={findAllConvenios}
                    withPaginate
                    value={filters.convenio}
                    onChange={handleChangeConvenio}
                    debounceTimeout={300}
                    additional={{
                      page: 0,
                    }}
                    getOptionLabel={(option)=> option.descricao}
                    getOptionValue={(option)=> option.id}
                  />
                </Grid>
                <Grid item xs={3} className={classes.spacing}>
                  <span className={classes.tituloFiltros}> Tipo atendimento: </span>
                  <ReactSelect
                    id="rel-rps-sel-tip"
                    placeholder="Selecione"
                    options={tiposAtendimento || []}
                    value={filters.tipo}
                    onChange={handleChangeTipoAtendimento}
                    getOptionLabel={(option) => option.descricao}
                    getOptionValue={(option) => option.id}
                    isClearable
                  />
                </Grid>
                <Grid item xs={3} className={classes.spacing}>
                  <span className={classes.tituloFiltros}> Situação: </span>
                  <PopperCheck
                    id="rel-rps-pop-sit"
                    options={situacoesList}
                    changeCheckbox={changeCheckbox}
                    label={quantidadeChecked()}
                  />
                </Grid>
      </div>

      <div className={classes.contentTableRepasse}>
        <div className={classes.containerTable}>
          {agendamentosRepasses.length === 0 && !loading &&
            <div className={classes.notFoundContainer}>
              <h3>Nenhum item encontrado</h3>
            </div>
          }
          {agendamentosRepasses.length > 0 &&
            <Table
              className={classes.table}
              dados={agendamentosRepasses}
              columns={columns}
              clickable={false}
              comOrdenacao
              ordenarTabela={ordenarTabela}
              handleClickOrdenar={handleClickOrdenar}
            />
          }
          {
            loading && <Grid
              container
              justify="center"
              alignItems="center"
              style={{ marginTop: "4px" }}
            >
              <CircularProgress size={30} />
            </Grid>
          }
        </div>
        <div className={classes.buttonsDownloadPrint}>
          <Button
            id="rel-rps-btn-csv"
            onClick={getCsv}
            shape='circle'
            bgColor='#707C97'
          >
            <ArrowDownloadIcon />
          </Button>
          <Button
            id="rel-rps-btn-imp"
            onClick={printRelatorio}
            shape='circle'
            bgColor='#F9BE73'
          >
            <PrintIcon />
          </Button>
        </div>
      </div>
      { printing && 
        <ImpressaoHtml
          isPrintMustache={printing}
          handlePrintMustache={() => setPrinting(false)}
          htmlStringComponent={ <RelatorioRepasseSinteticoPdf
            filter={filters}
            situacoesList={situacoesList}
            search={search}
            repasses={agendamentosRepasses}
            tiposAtendimento={tiposAtendimento}
          />}
        />}
      <Notification
        close={() => configuracaoImpressaoStore.closeNotification()}
        reset={() => configuracaoImpressaoStore.closeNotification()}
        isOpen={notification.isOpen}
        variant={notification.variant}
        message={notification.message}
      />
    </div>
  );
});

const RelatorioRepasseSinteticoWithStyles = withStyles(styles)(RelatorioRepasseSintetico)
export default inject("configuracaoImpressaoStore")(RelatorioRepasseSinteticoWithStyles)
